module.exports = "<kendo-grid \n[data]=\"progress\" [height]=\"800\"\n[pageable]=\"false\"\n>\n  <kendo-grid-column  field=\"status\" title=\"Status\" width=\"100\"> \n    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex=\"rowIndex\">\n      <span [ngClass]=\"getStatusClass(dataItem.Status)\">{{dataItem.Status}}</span> \n    </ng-template> \n  </kendo-grid-column>\n  <kendo-grid-column  field=\"Description\" title=\"Table\"> </kendo-grid-column>\n</kendo-grid>"


//////////////////
// WEBPACK FOOTER
// ./src/app/progress/progress.component.html
// module id = ./src/app/progress/progress.component.html
// module chunks = main